import { render, staticRenderFns } from "./course_description.vue?vue&type=template&id=2cb97fe4&scoped=true&"
import script from "./course_description.vue?vue&type=script&lang=js&"
export * from "./course_description.vue?vue&type=script&lang=js&"
import style0 from "./course_description.vue?vue&type=style&index=0&id=2cb97fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb97fe4",
  null
  
)

export default component.exports